import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'

const usePrevious = value => {
  const ref = useRef()

  useEffect(() => {
    ref.current = value
  })
  return ref.current
}

const ScrollToTop = props => {
  const location = useLocation()
  const prevLocation = usePrevious(location)

  useEffect(() => {
    if (location.pathname !== prevLocation?.pathname) {
      window.scrollTo(0, 0)
    }
  })

  return props.children
}

export default ScrollToTop